<ng-container *ngIf="userForm">
	<div class="main-content">
		<div class="container-fluid">
			<div class="row m-0 p-0">
				<div class="col-md-12 m-0 p-0">
					<div class="card">
						<div class="card-header card-header-{{color}}-2">
							<h4 class="card-title"> <i class="material-icons" (click)="back()">arrow_left</i>Edit Profile</h4>
							<p class="card-category text-right">Update your profile</p>
						</div>
						<div class="card-body">
							<mat-tab-group #tabPanel mat-align-tabs="start" class="" color="accent">
								<mat-tab label="Profile">
									<form [formGroup]="userForm" class="text-dark mt-3 profile-form" (submit)="updateUser()">
										<div class="card card-body">
											<div class="row">
												<div class="col-md-6">
													<mat-form-field class="full-width" appearance="outline">
														<mat-label>User Id</mat-label>
														<input matInput formControlName="userid">
													</mat-form-field>
												</div>
												<div class="col-md-6" [ngClass]="isPosUser ? 'd-none' : ''">
													<mat-form-field class="full-width" appearance="outline">
														<mat-label>Password</mat-label>
														<input matInput formControlName="password" type="password">
													</mat-form-field>
												</div>
												<div class="col-md-6">
													<mat-form-field class="full-width" appearance="outline">
														<mat-label>Name</mat-label>
														<input matInput formControlName="realname">
													</mat-form-field>
												</div>
												<div class="col-md-6">
													<mat-form-field class="full-width" appearance="outline">
														<mat-label>Email address</mat-label>
														<input matInput formControlName="email" type="email">
													</mat-form-field>
												</div>
											</div>

											<div class="row mt-3">
												<div class="col-md-6">
													<mat-form-field class="full-width" appearance="outline">
														<mat-label>Phone#</mat-label>
														<input matInput formControlName="phone" type="tel">
													</mat-form-field>
												</div>
												<div class="col-md-6">
													<mat-form-field class="full-width" appearance="outline">
														<mat-label>Default Location</mat-label>
														<mat-select formControlName="defaultlocation">
															<mat-option *ngFor="let loc of locations" [value]="loc.loccode">
																{{ loc.loccode }} - {{ loc.locationname }}
															</mat-option>
														</mat-select>
													</mat-form-field>
												</div>
											</div>

											<!-- Full Access Section -->
											<div class="row mt-3" *ngIf="user.fullaccess == '8'">
												<div class="col-md-6">
													<mat-form-field class="full-width" appearance="outline">
														<mat-label>Full Access</mat-label>
														<input matInput formControlName="fullaccess" type="text">
													</mat-form-field>
												</div>
											</div>

											<!-- Additional Settings -->
											<div class="row mt-3" *ngIf="user.fullaccess == '8'">
												<div class="col-md-3">
													<mat-form-field class="full-width" appearance="outline">
														<mat-label>Customer Admin</mat-label>
														<mat-select formControlName="customeradmin">
															<mat-option *ngFor="let yn of yesno" [value]="yn.value">{{ yn.name }}</mat-option>
														</mat-select>
													</mat-form-field>
												</div>
												<div class="col-md-3">
													<mat-form-field class="full-width" appearance="outline">
														<mat-label>Create Tender</mat-label>
														<mat-select formControlName="cancreatetender">
															<mat-option *ngFor="let yn of yesno" [value]="yn.value">{{ yn.name }}</mat-option>
														</mat-select>
													</mat-form-field>
												</div>
												<div class="col-md-3">
													<mat-form-field class="full-width" appearance="outline">
														<mat-label>Edit Inventory</mat-label>
														<mat-select formControlName="editinv">
															<mat-option *ngFor="let yn of yesno" [value]="yn.value">{{ yn.name }}</mat-option>
														</mat-select>
													</mat-form-field>
												</div>
												<div class="col-md-3">
													<mat-form-field class="full-width" appearance="outline">
														<mat-label>Dispatch Admin</mat-label>
														<mat-select formControlName="dispatchadmin">
															<mat-option *ngFor="let yn of yesno" [value]="yn.value">{{ yn.name }}</mat-option>
														</mat-select>
													</mat-form-field>
												</div>
											</div>

											<!-- Color Picker -->
											<div class="row mt-4 mb-4 text-center">
												<div class="col-12">
													<label class="color-label">Color Schema</label>
													<div class="profile-plugin switch-trigger active-color">
													  <span class="badge filter badge-purple"
															data-color="purple"
															[ngClass]="{'active': color === 'purple'}"
															(click)="changColor('purple')">
													  </span>
													  
													  <span class="badge filter badge-azure"
															data-color="azure"
															[ngClass]="{'active': color === 'azure'}"
															(click)="changColor('azure')">
													  </span>
													  
													  <span class="badge filter badge-green"
															data-color="green"
															[ngClass]="{'active': color === 'green'}"
															(click)="changColor('green')">
													  </span>
													
													  <span class="badge filter badge-red"
															data-color="red"
															[ngClass]="{'active': color === 'red'}"
															(click)="changColor('red')">
													  </span>
													</div>
												</div>


											</div>

											<!-- Submit Button -->
											<div class="row">
												<div class="col-12 text-right">
													<button mat-raised-button type="submit" color="primary" class="update-button">Update Profile</button>
												</div>
											</div>
										</div>

									</form>
								</mat-tab>



								<mat-tab label="Printers">
									<div class="printers-pane">

										<!-- Setup guide -->
										<mat-accordion class="w-100">
											<mat-expansion-panel class="setup-guide" [expanded]="false">
												<mat-expansion-panel-header>
													<mat-panel-title>
														<span class="setup-title"><mat-icon>help_outline</mat-icon> Printer Setup Guide</span>
													</mat-panel-title>
												</mat-expansion-panel-header>
												<ol class="setup-steps">
													<li>Open <strong>Print Connect</strong> on this computer and note the <strong>Machine Name</strong> shown at the top of the window — that's the name you must choose here.</li>
													<li>In <strong>Available Printers</strong> below, find the device whose name <strong>exactly matches</strong> that Machine Name, pick its <strong>Device Types</strong> (Invoice, Label, Receipt…), then click <strong>Add</strong>.</li>
													<li>Your selection appears under <strong>My Printers</strong>. If the <strong>same printer appears twice</strong>, it prints twice for every job — keep only one entry.</li>
												</ol>
												<p class="setup-note">
													<mat-icon>info</mat-icon>
													<span><strong>Nothing under My Printers?</strong> Nothing prints. It doesn't need to be on the same network — just set up on <em>this</em> computer. If a printer shows “Disconnected”, refresh the page you're printing from.</span>
												</p>
											</mat-expansion-panel>
										</mat-accordion>

										<!-- Two-column grid -->
										<div class="printers-grid">

											<!-- Available Printers -->
											<section class="printer-column is-available">
												<header class="column-head">
													<div class="column-title">
														<mat-icon>devices_other</mat-icon>
														<span>Available Printers</span>
														<span class="count-pill">{{ filteredAvailableDevices().length }}</span>
													</div>
													<button mat-icon-button (click)="refreshCompanyDevices()" matTooltip="Refresh list">
														<mat-icon>refresh</mat-icon>
													</button>
												</header>

												<mat-form-field appearance="outline" class="printer-search w-100">
													<mat-label>Search available printers</mat-label>
													<input matInput [(ngModel)]="searchAvailableDevices" placeholder="Name or device ID">
													<button mat-icon-button matSuffix *ngIf="searchAvailableDevices" (click)="searchAvailableDevices = ''" matTooltip="Clear search">
														<mat-icon>clear</mat-icon>
													</button>
												</mat-form-field>

												<div class="empty-state" *ngIf="filteredAvailableDevices().length === 0">
													<mat-icon>print_disabled</mat-icon>
													<p>No printers available.<br><small>Set one up in Print Connect, then refresh.</small></p>
												</div>

												<div class="printer-card" *ngFor="let device of filteredAvailableDevices()">
													<div class="pc-top">
														<div class="pc-icon"><mat-icon>print</mat-icon></div>
														<div class="pc-body">
															<div class="pc-head">
																<span class="pc-name">{{ device.machine_name }}</span>
															</div>
															<div class="pc-meta">
																<span *ngIf="device.ip"><mat-icon>router</mat-icon>{{ device.ip }}</span>
																<span><mat-icon>person</mat-icon>{{ device.machine_user || '—' }}</span>
															</div>
															<div class="pc-types-label">Route these jobs to this printer</div>
															<div class="pc-types">
																<button type="button" class="type-chip" *ngFor="let type of deviceTypes"
																	[class.on]="availableSelectedTypes(device).includes(type)"
																	[attr.data-type]="type"
																	(click)="toggleAvailableType(device, type)">{{ type }}</button>
															</div>
														</div>
													</div>
													<div class="pc-footer">
														<span class="pc-hint" *ngIf="availableSelectedTypes(device).length === 0">Pick at least one job type</span>
														<button mat-flat-button color="primary" (click)="addUserDevice(device)" [disabled]="availableSelectedTypes(device).length === 0">
															<mat-icon>add</mat-icon> Add
														</button>
													</div>
												</div>
											</section>

											<!-- My Printers -->
											<section class="printer-column is-assigned">
												<header class="column-head">
													<div class="column-title">
														<mat-icon>check_circle</mat-icon>
														<span>My Printers</span>
														<span class="count-pill">{{ filteredUserDevices().length }}</span>
													</div>
												</header>

												<mat-form-field appearance="outline" class="printer-search w-100">
													<mat-label>Search my printers</mat-label>
													<input matInput [(ngModel)]="searchUserDevices" placeholder="Name or device ID">
													<button mat-icon-button matSuffix *ngIf="searchUserDevices" (click)="searchUserDevices = ''" matTooltip="Clear search">
														<mat-icon>clear</mat-icon>
													</button>
												</mat-form-field>

												<div class="empty-state" *ngIf="filteredUserDevices().length === 0">
													<mat-icon>print_disabled</mat-icon>
													<p>No printers assigned to your profile.<br><small>Add one from the list on the left.</small></p>
												</div>

												<div class="printer-card assigned" *ngFor="let device of filteredUserDevices()"
													[class.is-duplicate]="duplicateUserMachineNames().has(device.machineName)">
													<div class="pc-top">
														<div class="pc-icon"><mat-icon>print</mat-icon></div>
														<div class="pc-body">
															<div class="pc-head">
																<span class="pc-name">{{ device.machineName }}</span>
																<span class="pc-dupe-badge" *ngIf="duplicateUserMachineNames().has(device.machineName)" matTooltip="This machine is assigned more than once — every job prints twice. Remove the extra entry.">
																	<mat-icon>warning</mat-icon> Duplicate
																</span>
															</div>
															<div class="pc-meta">
																<span><mat-icon>person</mat-icon>{{ device.machineUser || '—' }}</span>
															</div>
															<div class="pc-types-label">Prints these jobs</div>
															<div class="pc-types">
																<button type="button" class="type-chip" *ngFor="let type of deviceTypes"
																	[class.on]="(device.deviceTypes || []).includes(type)"
																	[attr.data-type]="type"
																	(click)="toggleUserType(device, type)">{{ type }}</button>
															</div>
															<div class="pc-empty-types" *ngIf="!(device.deviceTypes || []).length">
																<mat-icon>info</mat-icon> No job types selected — this printer won't receive anything.
															</div>
															<div class="pc-test-msg" *ngIf="deviceTestMsg[device.deviceID + '_' + device.machineName]">{{ deviceTestMsg[device.deviceID + '_' + device.machineName] }}</div>
														</div>
													</div>
													<div class="pc-footer">
														<button mat-stroked-button color="primary" (click)="testPrinter(device)" matTooltip="Send a test page to this printer">
															<mat-icon>print</mat-icon> Test
														</button>
														<button mat-stroked-button color="warn" (click)="removeUserDevice(device)" matTooltip="Remove from my profile">
															<mat-icon>delete</mat-icon> Remove
														</button>
													</div>
												</div>
											</section>
										</div>
									</div>
								</mat-tab>

								<mat-tab label="Terminals">
									<div class="terminals-pane">

										<!-- Setup guide -->
										<mat-accordion class="w-100">
											<mat-expansion-panel class="setup-guide" [expanded]="false">
												<mat-expansion-panel-header>
													<mat-panel-title>
														<span class="setup-title"><mat-icon>help_outline</mat-icon> Terminal Setup Guide</span>
													</mat-panel-title>
												</mat-expansion-panel-header>
												<ol class="setup-steps">
													<li>Open <strong>Print Connect</strong> on this computer and go to the <strong>Terminals</strong> tab. Connect your payment terminal there first.</li>
													<li>In <strong>Available Terminals</strong> below, find the terminal you want to use and click <strong>Add</strong> to assign it to your profile.</li>
													<li>Your selection appears under <strong>My Terminals</strong> and will be used for card payments in POS.</li>
												</ol>
												<p class="setup-note">
													<mat-icon>info</mat-icon>
													<span><strong>Terminal not showing?</strong> Make sure Print Connect is running and the terminal is connected in its Terminals tab, then hit refresh.</span>
												</p>
											</mat-expansion-panel>
										</mat-accordion>

										<!-- Two-column grid -->
										<div class="terminals-grid">

											<!-- Available Terminals -->
											<section class="terminal-column is-available">
												<header class="column-head">
													<div class="column-title">
														<mat-icon>devices_other</mat-icon>
														<span>Available Terminals</span>
														<span class="count-pill">{{ getAvailableTerminals().length }}</span>
													</div>
													<button mat-icon-button (click)="refreshCompanyTerminals()" matTooltip="Refresh list">
														<mat-icon>refresh</mat-icon>
													</button>
												</header>

												<div class="empty-state" *ngIf="getAvailableTerminals().length === 0">
													<mat-icon>point_of_sale</mat-icon>
													<p>No terminals available.<br><small>Connect a terminal in Print Connect, then refresh.</small></p>
												</div>

												<ng-container *ngFor="let terminal of getAvailableTerminals()">
													<ng-container *ngTemplateOutlet="terminalCard; context: { terminal: terminal, assigned: false }"></ng-container>
												</ng-container>
											</section>

											<!-- My Terminals -->
											<section class="terminal-column is-assigned">
												<header class="column-head">
													<div class="column-title">
														<mat-icon>check_circle</mat-icon>
														<span>My Terminals</span>
														<span class="count-pill">{{ (user_terminals || []).length }}</span>
													</div>
												</header>

												<div class="empty-state" *ngIf="(user_terminals || []).length === 0">
													<mat-icon>credit_card</mat-icon>
													<p>No terminals assigned to your profile.<br><small>Add one from the list on the left.</small></p>
												</div>

												<ng-container *ngFor="let terminal of user_terminals">
													<ng-container *ngTemplateOutlet="terminalCard; context: { terminal: terminal, assigned: true }"></ng-container>
												</ng-container>
											</section>
										</div>

										<!-- Batch & Sync (full width) -->
										<section class="batch-sync-card" *ngIf="(user_terminals || []).length">
											<div class="bs-head">
												<mat-icon>sync</mat-icon>
												<span>Batch &amp; Sync</span>
											</div>
											<div class="bs-body">
												<div class="bs-controls">
													<mat-form-field appearance="outline" class="bs-terminal-select">
														<mat-label>Terminal</mat-label>
														<mat-select [(ngModel)]="selectedBatchTerminalId" (selectionChange)="onBatchTerminalChange()">
															<mat-option *ngFor="let terminal of user_terminals" [value]="terminal.terminal_id">
																{{ terminal.terminal_name || terminal.terminal_id }}
															</mat-option>
														</mat-select>
													</mat-form-field>
													<div class="bs-pending" [class.has-pending]="pendingSyncCount > 0">
														<span class="bs-pending-label">Pending sync</span>
														<span class="bs-pending-count">
															<ng-container *ngIf="pendingSyncLoading">…</ng-container>
															<ng-container *ngIf="!pendingSyncLoading">{{ pendingSyncCount }}</ng-container>
														</span>
													</div>
												</div>

												<div class="bs-error" *ngIf="pendingSyncError">
													<mat-icon>error_outline</mat-icon>{{ pendingSyncError }}
												</div>

												<div class="bs-actions">
													<button mat-stroked-button (click)="retryPendingSync()" [disabled]="pendingSyncLoading">
														<mat-icon>refresh</mat-icon> Retry Sync
													</button>
													<button mat-stroked-button color="primary" (click)="runBatchSubtotal()" [disabled]="batchInProgress">
														<mat-icon>receipt_long</mat-icon> Batch Subtotal
													</button>
													<button mat-flat-button color="warn" (click)="runBatchClose()" [disabled]="batchInProgress">
														<mat-icon>lock</mat-icon> Batch Close
													</button>
												</div>

												<div class="bs-result" *ngIf="batchResult && !batchResult.error">
													<mat-icon>check_circle</mat-icon>
													<span *ngIf="batchResult.batch_number">Batch {{ batchResult.batch_number }} • Balanced: {{ batchResult.batch_balanced ? 'Yes' : 'No' }}</span>
													<span *ngIf="!batchResult.batch_number">{{ batchResult.message || 'Batch completed' }}</span>
												</div>
												<div class="bs-result error" *ngIf="batchResult?.error">
													<mat-icon>error_outline</mat-icon>{{ batchResult.error }}
												</div>
											</div>
										</section>

										<!-- Shared terminal card template -->
										<ng-template #terminalCard let-terminal="terminal" let-assigned="assigned">
											<div class="terminal-card" [class.assigned]="assigned">
												<ng-container *ngIf="editingTerminalId !== terminal.terminal_id; else terminalEdit">
													<div class="tc-top">
														<div class="tc-icon"><mat-icon>point_of_sale</mat-icon></div>
														<div class="tc-body">
															<div class="tc-head">
																<span class="tc-name">{{ terminal.terminal_name }}</span>
																<span class="tc-type">{{ terminal.terminal_type === 'td_tetra' ? 'TD Bank' : terminal.terminal_type === 'ingenico' ? 'Ingenico' : terminal.terminal_type }}</span>
															</div>
															<div class="tc-meta">
																<span><mat-icon>computer</mat-icon>{{ terminal.machine_name || '—' }}</span>
																<span><mat-icon>person</mat-icon>{{ terminal.machine_user || '—' }}</span>
																<span class="tc-conn" *ngIf="terminal.connection_type">{{ terminal.connection_type | uppercase }}</span>
															</div>
															<div class="tc-meta tc-meta-sub" *ngIf="(terminal.terminal_model && terminal.terminal_model !== 'unknown') || (terminal.terminal_serial && terminal.terminal_serial !== 'UNKNOWN' && terminal.terminal_serial !== 'unknown')">
																<span *ngIf="terminal.terminal_model && terminal.terminal_model !== 'unknown'">{{ terminal.terminal_model === 'imove5000' ? 'iMove 5000' : terminal.terminal_model === 'desk5000' ? 'Desk 5000' : terminal.terminal_model }}</span>
																<span *ngIf="terminal.terminal_serial && terminal.terminal_serial !== 'UNKNOWN' && terminal.terminal_serial !== 'unknown'">SN&nbsp;{{ terminal.terminal_serial }}</span>
															</div>
															<div class="tc-test-msg" *ngIf="assigned && terminalTestMsg[terminal.terminal_id]">{{ terminalTestMsg[terminal.terminal_id] }}</div>
														</div>
													</div>
													<div class="tc-footer">
														<button *ngIf="assigned" mat-stroked-button color="primary" (click)="testTerminal(terminal)" matTooltip="Run a $0.01 test sale">
															<mat-icon>wifi_tethering</mat-icon> Test
														</button>
														<button mat-stroked-button (click)="startEditTerminal(terminal)" matTooltip="Edit details">
															<mat-icon>edit</mat-icon> Edit
														</button>
														<button *ngIf="!assigned" mat-flat-button color="primary" (click)="addUserTerminal(terminal)">
															<mat-icon>add</mat-icon> Add
														</button>
														<button *ngIf="assigned" mat-stroked-button color="warn" (click)="removeUserTerminal(terminal)" matTooltip="Remove from my profile">
															<mat-icon>delete</mat-icon> Remove
														</button>
													</div>
												</ng-container>
												<ng-template #terminalEdit>
													<div class="tc-edit">
														<h6 class="tc-edit-title">Edit terminal</h6>
														<mat-form-field appearance="outline">
															<mat-label>Terminal name</mat-label>
															<input matInput [(ngModel)]="editTerminalName">
														</mat-form-field>
														<mat-form-field appearance="outline">
															<mat-label>Machine name</mat-label>
															<input matInput [(ngModel)]="editMachineName">
														</mat-form-field>
														<mat-form-field appearance="outline">
															<mat-label>Machine user</mat-label>
															<input matInput [(ngModel)]="editMachineUser">
														</mat-form-field>
														<div class="tc-edit-buttons">
															<button mat-flat-button color="primary" (click)="saveTerminalEdit()">Save</button>
															<button mat-button (click)="cancelTerminalEdit()">Cancel</button>
														</div>
													</div>
												</ng-template>
											</div>
										</ng-template>

									</div>
								</mat-tab>

								<mat-tab label="Favorites">
									<div class="row m-0 p-0 mt-4">
										<div class="col-md-12">
										<button *ngIf="saveavailable" mat-raised-button color="success" class="ml-2" (click)="reorderFavorites()" matTooltip="Save Changes">
										<mat-icon>save</mat-icon> Save Changes and Reload
										</button>
										<div class="scrollable-table">
											<div *ngIf="favorites.length != 0">
												<div cdkDropList class="product-drop-list" (cdkDropListDropped)="drop($event)">
													<div *ngFor="let fave of favorites" class="product-drop-box" cdkDrag>
														<button mat-icon-button color="warn" (click)="removeFavorites(fave.faveid)">
															<mat-icon>delete</mat-icon>
														</button>
														<div class="item-info">
															<b>{{fave.title}}</b><br>
														</div>
													</div>
												</div>
											</div>
											<div class="no-results" *ngIf="favorites.length == 0">
												No Favorites Added
											</div>
										</div>
										</div>
									</div>
								</mat-tab>
								<mat-tab label='Dashboard Editor'>
									<ng-template matTabContent>
										<app-user-dashboard-editor></app-user-dashboard-editor>
									</ng-template>
								</mat-tab>
							</mat-tab-group>
						</div>
					</div>
				</div>
				<div class="col-md-4 d-none">
					<div class="card card-profile">
						<div class="card-avatar">
							<a href="javascript:void(0)">
								<img class="img" src="./assets/img/faces/marc.jpg" />
							</a>
						</div>
						<div class="card-body">
							<h6 class="card-category text-gray">CEO / Co-Founder</h6>
							<h4 class="card-title">{{ userdetails.realname }}</h4>
							<p class="card-description">
								Don't be scared of the truth because we need to restart the human foundation in truth And I love you like Kanye loves Kanye I love Rick Owens’ bed design but the back is...
							</p>
							<a href="javascript:void(0)" class="btn btn-danger btn-round">Follow</a>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</ng-container>